import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const SkeletonWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  background-color: var(--colorBlueGray1100);
  text-transform: none;
  position: relative;
  overflow: hidden;
  padding: 24px 24px 16px 24px;
  border-radius: 0px;
  border-bottom: 1px solid var(--colorBlueGray1000);
  animation: ${pulse} 2s ease-in-out infinite;
`;

const ImageSkeleton = styled.div`
  width: 384px;
  height: 240px;
  border-radius: 8px;
  background-color: var(--colorBlueGray1000);
  flex-shrink: 0;
`;

const TextBlockSkeleton = styled.div<{ width: string; height: string }>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: 4px;
  background-color: var(--colorBlueGray1000);
  margin-bottom: 8px;
`;

const FeatureSkeleton: FC = () => (
  <SkeletonWrapper>
    <Box display="flex" gap="small" flexDirection="row-reverse" alignItems="flex-start">
      <ImageSkeleton />
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <TextBlockSkeleton width="120px" height="16px" />
        <TextBlockSkeleton width="240px" height="24px" />
        <TextBlockSkeleton width="320px" height="16px" />
        <TextBlockSkeleton width="300px" height="16px" />
      </Box>
    </Box>
  </SkeletonWrapper>
);

export default FeatureSkeleton;
